export default "__VITE_ASSET__C9Tdk8ET__"